import { render, staticRenderFns } from "./PageStarts.vue?vue&type=template&id=6a4e0e1c&"
import script from "./PageStarts.vue?vue&type=script&lang=js&"
export * from "./PageStarts.vue?vue&type=script&lang=js&"
import style0 from "./PageStarts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports